import PolicyDetailVehicle from './PolicyDetailVehicle';
export default PolicyDetailVehicle;
